import React, { useEffect } from "react";
import "./offer-banner.css";

import { getAllBanner } from "../../../features/home/homeSlice";

import { useDispatch, useSelector } from "react-redux";

const Offer_banner = () => {
  const dispatch = useDispatch();

  /* ==========================================================
     GET BANNER
     ========================================================== */

  const allbanners = useSelector((state) => state.home.allbanners);

  useEffect(() => {
    dispatch(
      getAllBanner({
        banner_type_id: 1,
      }),
    );
  }, [dispatch]);

  const imageUrl = allbanners?.image
    ? process.env.REACT_APP_IMAGE_URL + allbanners.image
    : null;

  const videoUrl = allbanners?.video
    ? process.env.REACT_APP_IMAGE_URL + allbanners.video
    : null;

  const mediaUrl = videoUrl || imageUrl;

  /* ==========================================================
     CHECK MEDIA TYPE
     ========================================================== */

  const isVideo =
    !!videoUrl || /\.(mp4|webm|ogg)(\?.*)?$/i.test(mediaUrl || "");

  if (!mediaUrl) {
    return null;
  }

  return (
    <section className="Offer_banner_sec">
      <div className="offerbanerdiv">
        {isVideo ? (
          <video
            className="offerbanner"
            src={mediaUrl}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
          >
            Your browser does not support the video tag.
          </video>
        ) : (
          <img className="offerbanner" src={mediaUrl} alt="Bapat Opticians" />
        )}
      </div>
    </section>
  );
};

export default Offer_banner;
